import React, { useState } from "react";

interface DeleteButtonProps {
  onDelete: () => void;
  confirmText?: string;
  cancelText?: string;
  buttonSize?: "sm" | "md" | "lg";
}

/**
 * A button component that requires confirmation before executing a delete action
 */
const DeleteButton: React.FC<DeleteButtonProps> = ({
  onDelete,
  confirmText = "Delete",
  cancelText = "Cancel",
  buttonSize = "sm",
}) => {
  const [showConfirm, setShowConfirm] = useState(false);

  const handleDelete = () => {
    onDelete();
    setShowConfirm(false);
  };

  const buttonClass = {
    sm: "btn-sm",
    md: "btn",
    lg: "btn-lg",
  }[buttonSize];

  return (
    <>
      {!showConfirm ? (
        <button
          className={`${buttonClass} border-red-500 hover:border-red-600 text-red-500 hover:text-red-600`}
          onClick={() => setShowConfirm(true)}
        >
          <svg
            className="w-4 h-4 fill-current opacity-50 shrink-0"
            viewBox="0 0 16 16"
          >
            <path d="M5 7h2v6H5V7zm4 0h2v6H9V7zm3-6v2h4v2h-1v10c0 .6-.4 1-1 1H2c-.6 0-1-.4-1-1V5H0V3h4V1c0-.6.4-1 1-1h6c.6 0 1 .4 1 1zM6 2v1h4V2H6zm7 3H3v9h10V5z" />
          </svg>
        </button>
      ) : (
        <div className="flex space-x-1">
          <button
            className={`${buttonClass} bg-red-500 hover:bg-red-600 text-white`}
            onClick={handleDelete}
          >
            {confirmText}
          </button>
          <button
            className={`${buttonClass} border-gray-200 dark:border-gray-700 hover:border-gray-300 dark:hover:border-gray-600 text-gray-600 dark:text-gray-300`}
            onClick={() => setShowConfirm(false)}
          >
            {cancelText}
          </button>
        </div>
      )}
    </>
  );
};

export default DeleteButton;
